import React, { useEffect, useState } from 'react'
import Breadcrum from './breadcrum'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
// import { getCompanyWithId, updateCompany } from '../api/financialApi'
// import { validateCin } from '../api/dashboardApi'

const EditCompany = ({
  id = null,
  companyFrom = null,
  apiConfig: { updateFn, getFn },
}) => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [imagePreview, setImagePreview] = useState(null)
  // const [cinValidation, setCinValidation] = useState({
  //   isValidating: false,
  //   isValid: null,
  //   companyName: '',
  //   error: '',
  // })

  console.log('this is companyFrom:', companyFrom)

  useEffect(() => {
    document.title = 'Edit company details'
  }, [])

  const {
    register,
    watch,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      companyName: '',
      cin: '',
      companyLogo: null,
    },
  })

  // Updated React component validation function
  // const validateCIN = async (cinNumber) => {
  //   if (!cinNumber || cinNumber.length !== 21) {
  //     setCinValidation({
  //       isValidating: false,
  //       isValid: false,
  //       companyName: '',
  //       error: 'Invalid CIN format',
  //     })
  //     return
  //   }

  //   setCinValidation((prev) => ({ ...prev, isValidating: true }))

  //   try {
  //     setCinValidation((prev) => ({
  //       ...prev,
  //       isValidating: true,
  //     }))

  //     const res = await validateCin(cinNumber)
  //     console.log('Validation result:', res)

  //     if (res?.company) {
  //       setCinValidation({
  //         isValidating: false,
  //         isValid: true,
  //         companyName: res.company,
  //         error: '',
  //       })
  //     } else {
  //       setCinValidation({
  //         isValidating: false,
  //         isValid: false,
  //         companyName: '',
  //         error: res?.error || 'CIN not found',
  //       })
  //     }
  //   } catch (error) {
  //     console.error('CIN validation error:', error)
  //     setCinValidation({
  //       isValidating: false,
  //       isValid: false,
  //       companyName: '',
  //       error: error?.response?.data?.error || 'Error validating CIN',
  //     })
  //   }
  // }

  // 3. Add this useEffect to watch for CIN changes
  // useEffect(() => {
  //   const cinValue = watch('cin')
  //   if (cinValue && cinValue.length === 21) {
  //     const debounceTimer = setTimeout(() => {
  //       validateCIN(cinValue)
  //     }, 500) // 500ms delay to avoid too many API calls

  //     return () => clearTimeout(debounceTimer)
  //   } else if (cinValue && cinValue.length > 0) {
  //     setCinValidation({
  //       isValidating: false,
  //       isValid: null,
  //       companyName: '',
  //       error: '',
  //     })
  //   }
  // }, [watch('cin')])

  const {
    data: companyData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['companyData', id],
    queryFn: () => getFn(id),
    enabled: !!id,
    onError: (error) => {
      toast.error(
        error.response?.data?.message || 'Failed to load company data'
      )
    },
  })

  const populate = (data) => {
    if (!data) {
      return
    }
    setValue('companyName', data.companyName || '')
    setValue('cin', data.cin || '')

    if (data.companyLogoUrl) {
      setImagePreview(data.companyLogoUrl)
    }
  }

  useEffect(() => {
    if (companyData) {
      populate(companyData)
    }
  }, [companyData])

  // Update mutation
  const updateMutation = useMutation({
    mutationFn: (formData) => updateFn(id, formData),
    onSuccess: (data) => {
      toast.success('Company updated successfully!')
      queryClient.invalidateQueries(['companyData', id])
      if (companyFrom === 'financial') {
        queryClient.invalidateQueries(['financialData'])
        queryClient.invalidateQueries(['allCompanyData'])
        navigate(`/dealdashboard/financial/${id}`)
      } else {
        queryClient.invalidateQueries(['funding365'])
        queryClient.invalidateQueries(['funding365Data'])
        navigate(`/dealdashboard/funding/report/${id}`)
      }
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || 'Failed to update company')
    },
  })

  useEffect(() => {
    const imageFile = watch('companyLogo')
    if (imageFile && imageFile[0]) {
      const previewUrl = URL.createObjectURL(imageFile[0])
      setImagePreview(previewUrl)
      return () => URL.revokeObjectURL(previewUrl)
    }
  }, [watch('companyLogo')])

  const handleImageChange = (e) => {
    const files = e.target.files[0]
    if (files && files.length > 0) {
      // Set the file in form
      setValue('companyLogo', files)
    }
  }

  const onSubmit = (data) => {
    // if (!cinValidation.isValid) {
    //   setError('cin', {
    //     type: 'manual',
    //     message: 'Please enter a correct CIN number',
    //   })
    //   toast.error('Please enter a correct CIN number')
    //   return
    // }

    const formData = new FormData()
    formData.append('companyName', data.companyName)
    formData.append('cin', data.cin)

    // Only append logo if a new file is selected
    if (data.companyLogo && data.companyLogo[0]) {
      formData.append('companyLogo', data.companyLogo[0])
    }

    updateMutation.mutate(formData)
  }

  // Loading state
  if (isLoading) {
    return (
      <>
        <Breadcrum
          heading="Financial Company"
          subheading="Edit company detail"
        />
        <div className="text-center py-8">Loading company data...</div>
      </>
    )
  }

  // Error state
  if (isError) {
    return (
      <>
        <Breadcrum
          heading="Financial Company"
          subheading="Edit company detail"
        />
        <div className="text-center py-8 text-red-500">
          Error loading company data. Please try again later.
        </div>
      </>
    )
  }

  return (
    <>
      <Breadcrum heading="Financial Company" subheading="Edit company detail" />

      <div className="max-w-8xl text-left mx-auto px-4 py-6">
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Company Information Section */}
          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div className="bg-white p-6 rounded-xl shadow">
              <h2 className="font-semibold text-gray-800 mb-2">Company Name</h2>
              <input
                type="text"
                placeholder="Enter company name"
                className={`border ${
                  errors.companyName ? 'border-red-500' : 'border-gray-300'
                } rounded-lg p-3 w-full text-base focus:border-orange-500 focus:ring-orange-500 focus:outline-none`}
                {...register('companyName', {
                  required: 'Company name is required',
                 
                })}
              />
              {errors.companyName && (
                <p className="mt-1 text-red-500 text-sm">
                  {errors.companyName.message}
                </p>
              )}
            </div>

            <div className="bg-white p-6 rounded-xl shadow">
              <h2 className="font-semibold text-gray-800 mb-2">
                Company CIN Number
              </h2>
              <input
                type="text"
                placeholder="Enter CIN number"
                className={`border ${
                  errors.cin ? 'border-red-500' : 'border-gray-300'
                } rounded-lg p-3 w-full text-base focus:border-orange-500 focus:ring-orange-500 focus:outline-none`}
                {...register('cin', {
                  required: 'CIN number is required',
                  pattern: {
                    value: /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
                    message:
                      'Please enter a valid CIN number format (e.g., U12345MH2020PTC123456)',
                  },
                })}
              />
              {errors.cin && (
                <p className="mt-1 text-red-500 text-sm">
                  {errors.cin.message}
                </p>
              )}

              {/* CIN Validation Status */}
              {/* {cinValidation.isValidating && (
                <div className="flex items-center mt-2 text-blue-600">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
                  <span className="text-sm">Validating CIN...</span>
                </div>
              )}

              {cinValidation.isValid === true && (
                <div className="flex items-center mt-2 text-green-600">
                  <svg
                    className="h-4 w-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-sm font-medium">
                    {cinValidation.companyName}
                  </span>
                </div>
              )}

              {cinValidation.isValid === false && (
                <div className="flex items-center mt-2 text-red-600">
                  <svg
                    className="h-4 w-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                  <span className="text-sm">{cinValidation.error}</span>
                </div>
              )} */}
            </div>

            <div className="bg-white p-6 rounded-xl shadow md:col-span-2">
              <h2 className="font-semibold text-gray-800 mb-2">Company Logo</h2>
              {imagePreview && (
                <div className="mb-4">
                  <p className="text-sm text-gray-600 mb-2">Preview:</p>
                  <img
                    src={imagePreview}
                    alt="Logo preview"
                    className="max-h-32 w-auto object-contain rounded-lg border border-gray-200"
                  />
                </div>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="block w-full text-sm text-gray-700 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-orange-50 file:text-orange-600 hover:file:bg-orange-100"
                {...register('companyLogo', {
                  required: false,
                })}
              />
              {errors.companyLogo && (
                <p className="mt-1 text-red-500 text-sm">
                  {errors.companyLogo.message}
                </p>
              )}
            </div>
          </div>

          {/* Submit Button */}
          <div className="text-center">
            <div className="flex gap-4 justify-center">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="bg-gray-500 hover:bg-gray-600 text-white text-lg font-medium px-8 py-3 rounded-lg shadow-md transition-all"
              >
                Back
              </button>
              <button
                type="submit"
                disabled={updateMutation.isPending}
                className="bg-orange-500 hover:bg-orange-600 disabled:bg-orange-300 text-white text-lg font-medium px-8 py-3 rounded-lg shadow-md transition-all disabled:cursor-not-allowed"
              >
                {updateMutation.isPending
                  ? 'Updating Company...'
                  : 'Update Company'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default EditCompany
